export const selectColumnListIndustriesTable = [
  { optionKey: "Select Column", optionValue: "" },
  { optionKey: "Id", optionValue: "id" },
  { optionKey: "Industry Name", optionValue: "name" },
  { optionKey: "Description", optionValue: "description" },
];

export const sortByOptionIndustriesTable = [
  { optionKey: "Sort By Option", optionValue: "" },
  { optionKey: "Sort Ascending", optionValue: "asc" },
  { optionKey: "Sort Descending", optionValue: "dsc" },
];

